"use strict";

/**
 * @function
 * @description function to add a button after each input field which will erase input value when clicked
 * @param {string} elem - the parent element of the form that needs clear buttons after input fields
 */
const clearInputField = elem => {
    if (elem) {
        const elementInput = $(elem).find(".c-form__clear-fields input[type=text]:not(.c-input--fake, .cardNumber, .disabled)");

        $("<button type='button' class='clear-input-button d-lg-none'></button>").insertAfter(elementInput);
    } else {
        $("<button type='button' class='clear-input-button d-lg-none'></button>").insertAfter(".c-form__clear-fields input[type=text]:not(.c-input--fake, .cardNumber, .disabled), .c-form__clear-fields input[type=password], .c-form__clear-fields input[type=email]");
    }

    const $clearInputButton = $(".clear-input-button");

    $clearInputButton.on("click", e => {
        const $this = $(e.currentTarget);
        const $prevInput = $this.prev("input");

        if ($prevInput.length && $prevInput.val() !== "") {
            $prevInput.val("").trigger("focus");
        }
    });
};

module.exports = clearInputField;
